import {
  ACTION_SET_PAGE_CONTENT_AVAILABILITY__REQUEST,
  ACTION_SET_PAGE_CONTENT_AVAILABILITY__SUCCESS,
  ACTION_SET_PAGE_CONTENT_AVAILABILITY__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_SET_PAGE_CONTENT_AVAILABILITY__REQUEST:
    case ACTION_SET_PAGE_CONTENT_AVAILABILITY__SUCCESS:
      return null;

    case ACTION_SET_PAGE_CONTENT_AVAILABILITY__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
